module.exports = __webpack_public_path__ + "img/1.602b546e.jpg";